import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { useUserPermissionsStore } from "@/stores/UserPermissionsStore";
import { AccountDefaults } from "@/types/accounts/AccountDefaults";
import { CurrentUser } from "@/types/user/CurrentUser";
import { UserPermissions } from "@/types/user/permissions/UserPermissions";
import { ref, onMounted } from "vue";

export function useUserHelper() {
  const currentUserStore = useCurrentUserStore();
  const userPermissionsStore = useUserPermissionsStore();

  const currentUserDetails = ref<CurrentUser>(
    AccountDefaults.defaultCurrentUserDetails(),
  );
  const userPermissions = ref<UserPermissions>();

  const fetchUserDetails = async () => {
    currentUserDetails.value = await currentUserStore.getCurrentUserDetails();
  };

  const fetchUserPermissions = async () => {
    userPermissions.value = await userPermissionsStore.getUserPermissions();
  };

  onMounted(async () => {
    await fetchUserDetails();
    await fetchUserPermissions();
  });

  return {
    currentUserDetails,
    userPermissions,
    fetchUserDetails,
    fetchUserPermissions,
  };
}
